<template>
  <div
    class="vessel-edit flex w-full justify-start"
    style="flex-direction: column;"
  >
    <div
      ref="crewEditForm"
      style="height: calc(100vh - 220px); overflow-y: scroll; margin: 0 1rem;"
    >
      <div style="margin: 1rem 0;" class="required aisea-text-16-400-black">
        必要事項を入力してください。「<label></label>」は入力必須項目です。
      </div>

      <div v-if="inputParam.id">
        <!-- ポップアップ型ではなく、アコーディオンで埋め込む -->
        <vs-collapse accordion style="padding: 0;" ref="avatarCollapse">
          <vs-collapse-item open not-arrow>
            <!-- プロフィール画像 -->
            <div
              slot="header"
              id="collapse-header-avatar-area"
              style="width: 100%; padding: 0; height: 0;"
            ></div>
            <div style="position: relative;">
              <vs-avatar
                :src="avatar"
                :text="avatarText"
                :color="AISEA_COLOR.BLUE"
                class="flex-shrink-0 mr-2"
                size="64px"
                icon="directions_boat_filled"
                @click="toggleCollapse"
                style="margin-top: 1rem;"
              />
              <div
                style="font-size: xx-small; position: absolute; bottom: 12px; left: 26px; "
                :style="{ color: AISEA_COLOR.WHITE }"
              >
                {{ avatar ? "編集" : "登録" }}
              </div>
            </div>
          </vs-collapse-item>

          <vs-collapse-item not-arrow>
            <!-- プロフィール画像を変更する -->
            <div
              slot="header"
              id="collapse-header-work-area"
              style="width: 100%; padding: 0; height: 0;"
            ></div>
            <div class="flex w-full justify-center">
              <!-- enterprenterpriseManningVesselId を渡す必要があるので、新規では不可能 -->
              <embedded-upload-profile-image
                class="w-4/5"
                ref="dialogUploadProfileImage"
                :enterprenterpriseManningVesselId="inputParam.id"
                @onImageUploaded="onImageUploaded"
                @onImageUploadCancel="onImageUploadCancel"
              ></embedded-upload-profile-image>
            </div>
          </vs-collapse-item>
        </vs-collapse>
      </div>

      <div class="flex w-full justify-start items-start vessel-edit-form-row">
        <div class="w-full required">
          <vs-input
            class="w-full"
            label="船名"
            placeholder="例）アイディア丸"
            v-model="localData.name"
            v-validate="'required'"
            name="name"
            data-vv-as="船名"
            :color="AISEA_COLOR.BLUE"
          />
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem;"
            v-show="errors.has('name')"
            >{{ errors.first("name") }}</span
          >
        </div>
      </div>

      <div class="flex w-full justify-start items-start vessel-edit-form-row">
        <div class="flex w-full" style="flex-direction: column;">
          <div class="required">
            <label class="vs-input--label">船籍</label>
            <v-select
              name="country_code"
              v-model="countryCode"
              :clearable="false"
              :options="countryCodeList"
              label="name_localized"
              v-validate="'required'"
              data-vv-as="船籍"
              placeholder="船籍を選択してください"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              class="w-full"
            >
              <template v-slot:no-options>船籍が見つかりません</template>
            </v-select>
            <span
              class="text-danger text-sm"
              style="margin-left: 0.6rem;"
              v-show="errors.has('country_code')"
              >{{ errors.first("country_code") }}</span
            >
          </div>
          <div style="margin-left: 0.6rem;"></div>
        </div>
      </div>

      <div class="flex w-full justify-start items-start vessel-edit-form-row">
        <div class="flex w-full" style="flex-direction: column;">
          <div class="required">
            <label class="vs-input--label">船種</label>
            <v-select
              name="manning_vessel_category"
              v-model="manningVesselCategory"
              :clearable="false"
              :options="dispManningVesselCategoryList"
              label="dispName"
              v-validate="'required'"
              data-vv-as="船種"
              placeholder="船種を選択してください"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              class="w-full"
            >
              <template v-slot:no-options>船種が見つかりません</template>
            </v-select>
            <span
              class="text-danger text-sm"
              style="margin-left: 0.6rem;"
              v-show="errors.has('manning_vessel_category')"
              >{{ errors.first("manning_vessel_category") }}</span
            >
          </div>
          <div style="margin-left: 0.6rem;"></div>
        </div>
      </div>

      <div class="flex w-full justify-start items-start vessel-edit-form-row">
        <div class="w-full required">
          <vs-input
            class="w-full"
            label="総トン数"
            placeholder="例）499"
            v-model="localData.gross_tonnage"
            v-validate="'numeric|min_value:1|required'"
            name="gross_tonnage"
            data-vv-as="総トン数"
            :color="AISEA_COLOR.BLUE"
          />
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem;"
            v-show="errors.has('gross_tonnage')"
            >{{ errors.first("gross_tonnage") }}</span
          >
        </div>
      </div>

      <div class="flex w-full justify-start items-start vessel-edit-form-row">
        <div class="w-full">
          <vs-input
            class="w-full"
            label="船舶コード"
            placeholder="例）vessel1"
            v-model="localData.origin_code"
            v-validate="'half_size_alpha_num|max:128'"
            name="origin_code"
            data-vv-as="船舶コード"
            :color="AISEA_COLOR.BLUE"
          />
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem;"
            v-show="errors.has('origin_code')"
            >{{ errors.first("origin_code") }}</span
          >
        </div>
      </div>
    </div>

    <vs-divider style="margin: 0;" />

    <div class="flex w-full justify-end items-center">
      <div class="w-1/3 flex justify-start items-center" v-if="!inputParam.id">
        <!-- 
      <vs-checkbox v-model="continueFlg" :color="AISEA_COLOR.BLUE" /><span style="font-size: smaller;">続けて登録する</span>
      --></div>
      <div class="w-2/3 flex justify-end items-center">
        <div style="margin: 0.8rem;">
          <vs-button
            type="flat"
            style="width: 6rem; padding: 0.4rem;"
            :style="{ 'background-color': AISEA_COLOR.WHITE }"
            @click="onCancel"
            :color="AISEA_COLOR.GRAY"
            >キャンセル</vs-button
          >
        </div>
        <div style="margin: 0.8rem;">
          <vs-button
            style="width: 6rem; padding: 0.4rem;"
            @click="onSubmit"
            :disabled="
              ($refs.dialogUploadProfileImage &&
                $refs.dialogUploadProfileImage.isCrop) ||
                !validateForm
            "
            :color="AISEA_COLOR.BLUE"
            >保存</vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import vSelect from "vue-select";
import DatepickerMixin from "@/mixins/DatepickerMixin";
import { storage } from "@/firebase/firebaseConfig";
import EmbeddedUploadProfileImage from "./EmbeddedUploadProfileImage";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseManningVesselApi = AiseaApiFactory.get(
  "enterpriseManningVessel"
);
import { DeviceInfoMixin, ColorMixin } from "@/mixins";

export default {
  name: "ManningVessselEdit",
  components: {
    vSelect,
    EmbeddedUploadProfileImage,
  },
  mixins: [DatepickerMixin, DeviceInfoMixin, ColorMixin],
  props: {
    inputParam: Object,
    activeSidebarCrew: Boolean,

    countryCodeList: Array,
    manningVesselCategoryList: Array,
  },
  data() {
    return {
      avatar: null,
      avatarText: "",
      localData: {},
      continueFlg: false,
      manningVesselCategory: null,
      countryCode: null,
    };
  },
  computed: {
    dispManningVesselCategoryList() {
      return this.manningVesselCategoryList
        .map(manningVesselCategory => {
          manningVesselCategory.dispName = this.$t(
            "Views.Crew." + manningVesselCategory["localized_key"]
          );
          return manningVesselCategory;
        })
        .filter(x => x.dispName);
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.localData.name &&
        this.countryCode &&
        this.manningVesselCategory &&
        this.localData.gross_tonnage
      );
    },
  },
  watch: {
    activeSidebarCrew(val) {
      if (val) {
        this.initLocalData();
        this.$validator.reset();
      }
    },
  },
  methods: {
    initLocalData() {
      this.avatar = null;
      this.avatarText = "";

      if (this.inputParam.id) {
        // TODO: id があれば、idに紐づくデータを取得した後、 localDataとしてコピー。なければ最低限のlocalDataを生成
        this.localData = JSON.parse(JSON.stringify(this.inputParam));

        this.countryCode = this.localData.country_code
          ? this.countryCodeList.find(
              x => x.id === this.localData.country_code.id
            )
          : null;
        this.manningVesselCategory = this.localData.manning_vessel_category
          ? this.manningVesselCategoryList.find(
              x => x.id === this.localData.manning_vessel_category.id
            )
          : null;

        console.debug("### localData", this.localData);

        // this.avatarText = this.inputParam.name ? this.inputParam.name.charAt( 0 ) : '';
        if (this.inputParam.picture) {
          storage
            .child(this.inputParam.picture.thumbnail_path)
            .getDownloadURL()
            .then(response => {
              this.avatar = response;
            });
        }
      } else {
        this.continueFlg = this.inputParam.continueFlg;
        this.localData = {};
        this.countryCode = this.countryCodeList.find(x => x.id === "392"); // 392=日本
      }
    },

    toggleCollapse() {
      this.$el.querySelector("#collapse-header-work-area").click();
    },

    showDialogUpload() {
      this.$refs.dialogUploadProfileImage.show();
    },

    async onImageUploaded(pictureData) {
      this.localData.picture = pictureData.data;
      this.toggleCollapse();
      try {
        const origCountryCode = this.inputParam.country_code
          ? this.countryCodeList.find(
              x => x.id === this.inputParam.country_code.id
            )
          : null;
        const origManningVesselCategory = this.inputParam
          .manning_vessel_category
          ? this.manningVesselCategoryList.find(
              x => x.id === this.inputParam.manning_vessel_category.id
            )
          : null;
        let payload = {
          country_code: { id: origCountryCode ? origCountryCode.id : null },
          gross_tonnage: this.inputParam.gross_tonnage,
          origin_code: this.inputParam.origin_code,
          manning_vessel_category_id: origManningVesselCategory
            ? origManningVesselCategory.id
            : null,
          name: this.inputParam.name,
          picture: { id: this.localData.picture.id },
        };

        const res = await enterpriseManningVesselApi.update(
          this.inputParam.id,
          payload
        );
        if (res.status) {
          this.$vs.notify({
            title: `船舶情報設定`,
            text: `${this.localData.name}の画像を更新しました。`,
            color: "success",
            icon: "done",
          });
          this.avatar = null;
          storage
            .child(this.localData.picture.thumbnail_path)
            .getDownloadURL()
            .then(response => {
              this.avatar = response;
            });
          this.$emit("reloadList");
        } else {
          this.$vs.notify({
            title: `船舶情報設定`,
            text: `${this.localData.name}の画像を更新できませんでした。`,
            color: "danger",
            icon: "done",
          });
        }
      } catch (e) {
        this.$vs.notify({
          title: `船舶情報設定`,
          text: `${this.localData.name}の画像を更新できませんでした。`,
          color: "danger",
          icon: "done",
        });
      }
      this.$el.querySelector("#collapse-header-avatar-area").click();
    },

    onImageUploadCancel() {
      this.$el.querySelector("#collapse-header-avatar-area").click();
    },

    scrollEndAdjust() {
      setTimeout(() => {
        this.$refs.crewEditForm.scrollTop = this.$refs.crewEditForm.scrollHeight;
      }, 200);
    },

    onCancel() {
      this.localData = {};
      this.$nextTick(() => {
        this.$emit("close");
      });
    },
    async onSubmit() {
      let checkValidate = await this.$validator.validateAll();
      if (!checkValidate) {
        return false;
      }

      let payload = {
        country_code: { id: this.countryCode ? this.countryCode.id : null },
        gross_tonnage: this.localData.gross_tonnage,
        origin_code: this.localData.origin_code,
        manning_vessel_category_id: this.manningVesselCategory
          ? this.manningVesselCategory.id
          : null,
        name: this.localData.name,
      };

      if (this.inputParam.id) {
        // 更新APIをコール

        console.debug("### 更新API payload", this.inputParam.id, payload);

        try {
          this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
          const res = await enterpriseManningVesselApi.update(
            this.inputParam.id,
            payload
          );
          this.$vs.loading.close();
          if (res.status) {
            this.$vs.notify({
              title: `船舶情報設定`,
              text: `${this.localData.name}の船舶情報を更新しました。`,
              color: "success",
              icon: "done",
            });
          } else {
            Vue.$log.warn(
              "error at enterpriseManningVesselApi.update() ",
              this.inputParam.id,
              payload,
              res
            );
            this.$vs.notify({
              title: `船舶情報設定`,
              text: `${this.localData.name}の船舶情報を更新できませんでした。`,
              color: "warning",
              icon: "done",
            });
          }
        } catch (e) {
          Vue.$log.warn(
            "error at enterpriseManningVesselApi.update() ",
            this.inputParam.id,
            payload,
            e
          );
          this.$vs.notify({
            title: `船舶情報設定`,
            text: `${this.localData.name}の船舶情報を更新できませんでした。`,
            color: "warning",
            icon: "done",
          });
        }
      } else {
        // 登録APIをコール

        console.debug("### 登録API payload", payload);
        try {
          this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
          const res = await enterpriseManningVesselApi.add(payload);
          if (res.status) {
            this.localData.id = res.data.id;
            this.$vs.notify({
              title: `船舶情報設定`,
              text: `${this.localData.name}の登録が完了しました。`,
              color: "success",
              icon: "done",
            });
          } else {
            Vue.$log.warn(
              "error at enterpriseManningVesselApi.add() ",
              payload,
              res
            );
            this.$vs.notify({
              title: `船舶情報設定`,
              text: `${this.localData.name}の登録ができませんでした。`,
              color: "warning",
              icon: "done",
            });
          }
          this.$vs.loading.close();
        } catch (e) {
          this.$vs.loading.close();
          Vue.$log.warn(
            "error at enterpriseManningVesselApi.add() ",
            payload,
            e
          );
          this.$vs.notify({
            title: `船舶情報設定`,
            text: `${this.localData.name}の登録ができませんでした。`,
            color: "warning",
            icon: "done",
          });
        }
      }

      this.$emit("updatedId", this.localData.id);
      this.localData = {};

      this.$nextTick(() => {
        this.$emit("reloadList");
        this.$emit("close", this.continueFlg);
      });
    },
  },
  created() {
    this.initLocalData();
  },
  beforeDestroy() {},
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

.vessel-edit {
  label {
    font-family: $aisea-font-family;
    font-size: 14px;
    font-weight: 600;
  }

  .required label {
    &:after {
      content: " *";
      font-size: 0.8rem;
      color: rgba(var(--vs-danger), 1);
    }
  }

  .vs-inputx {
    color: $aisea-dark-gray !important;
    font-family: $aisea-font-family;
    font-size: 16px !important;
    font-weight: 400;
  }
  .vs-input--placeholder {
    color: $aisea-slightly-gray !important;
  }

  .v-select {
    font-family: $aisea-font-family;
    font-size: 16px;
    font-weight: 400;

    input {
      height: 2rem;
    }
  }

  .vessel-edit-form-row {
    flex-direction: column;
    margin: 1rem 0;
    padding-right: 8px;
  }

  .vs__search::placeholder {
    color: $aisea-light-gray;
  }

  .vdp-datepicker input {
    padding-left: 2.4rem;
  }

  .vs-collapse-item--header {
    padding: 0;
  }
  .vs-collapse-item {
    border-bottom: none;
  }
}
</style>
